<i18n>
{
  "en": {
    "ok": "ok",
    "cancel": "cancel"
  },
  "zh-tw": {
    "ok": "確認",
    "cancel": "取消"
  }
}
</i18n>

<template>
  <f7-popover id="prompt" :opened="true" :color-theme="themeColor">
    <div class="prompt-content-wrap">
      <div class="prompt-inner">
        <f7-list no-hairlines no-hairlines-between>
          <f7-list-item>
            <span class="prompt-title">{{ title }}</span>
          </f7-list-item>
          <f7-list-item>
            <span class="input-label" :style="labelStyle">{{ label }}</span>
          </f7-list-item>
          <f7-list-item>
            <f7-input
              inputStyle="height: 36px;"
              :value="value"
              :type="inputType"
              :placeholder="placeholder"
              :clearButton="clearButton"
              ref="input"
              @input="value = $event.target.value" />
          </f7-list-item>
        </f7-list>
      </div>
      <div class="prompt-buttons">
        <f7-button :style="{ 'width': '80px' }" @click="onCancel">{{ $t(`cancel`) }}</f7-button>
        <f7-button id="ok-btn" @click="onConfirm">{{ $t(`ok`) }}</f7-button>
      </div>
    </div>
  </f7-popover>
</template>

<script>
export default {
  name: 'Prompt',
  dependencies: ['themeColor'],
  props: {
    title: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: true
    },
    inputType: {
      type: String,
      default: 'text'
    },
    defaultValue: {
      type: String
    },
    clearButton: {
      type: Boolean,
      default: true
    },
    validator: {
      type: Function,
      default: () => true
    }
  },
  data () {
    return {
      value: this.defaultValue
    }
  },
  computed: {
    labelStyle () {
      return this.validator(this.value) ? {} : { color: 'red' }
    }
  },
  methods: {
    onConfirm () {
      this.$emit('confirm', this.value)
      this.$f7.views.main.router.back()
    },
    onCancel () {
      this.$emit('cancel', this.value)
      this.$f7.views.main.router.back()
    }
  },
  mounted () {
    if (this.autofocus) {
      this.$nextTick(() => {
        this.$refs.input.$el.querySelector('input').focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  #prompt {
    width: 280px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  .prompt-content-wrap {
    width: 280px;
    background-color: #FFFFFF;
    border-radius: 3px;
    box-shadow: 0 19px 38px rgba(0,0,0,.3), 0 15px 12px rgba(0,0,0,.22);
  }

  .prompt-title {
    font-size: 20px;
    line-height: 1.3;
    color: #212121;
  }

  .input-label {
    margin-top: 20px;
    line-height: 1.5;
    font-size: 16px;
    color: #757575;
  }

  .prompt-inner {
    box-sizing: border-box;
    width: 280px;
    padding: 24px 24px 20px 8px;
  }

  // override f7-list style
  .prompt-inner > div {
    margin: 0;
  }

  // override f7-list-item style
  .prompt-inner :global(div.item-content) {
    min-height: 0;
  }

  .prompt-inner :global(div.item-inner) {
    min-height: 0;
    padding: 0;
  }

  // override ios item-input-wrap style
  .prompt-inner :global(.item-input-wrap) {
    margin: 0;
  }

  :global(.ios) .prompt-inner :global(.item-input-wrap) {
    &:after {
      content: '';
      position: absolute;
      background-color: rgba(0,0,0,.12);
      display: block;
      z-index: 15;
      top: auto;
      right: auto;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
      transform-origin: 50% 100%;
      transition-duration: .2s;
    }
  }

  :global(.ios) {
    .prompt-inner :global(.item-input-focused) :global(.item-input-wrap)  {
      &:after {
        background: #4caf50;
        transform: scaleY(2);
      }
    }

    #prompt :global(.popover-angle) {
      display: none;
    }
  }

  :global(.ios) #prompt :global(.popover-angle) {
    display: none;
  }

  .prompt-buttons {
    padding: 6px 8px;
    display: flex;
    justify-content: flex-end;
  }

  .prompt-buttons a.button {
    width: 64px;
    height: 36px;
    line-height: 36px;

    &:last-child {
      margin-left: 4px;
    }
  }

  #ok-btn {
    font-weight: bold;
  }
</style>
